import { ModalOfflineComponent } from './../modal-offline/modal-offline.component';
import { LocalService } from './../../../../core/services/storage/local.service';
import { EmitService } from './../../../../core/services/utils/emit.service';
import { DecryptService } from './../../../../core/services/utils/decrypt.service';
import { AtencionService } from './../../../../core/services/http/atencion.service';
import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { ModalService } from 'src/app/core/services/utils/modal.service';
import { Component, OnInit } from '@angular/core';
import { SweetAlertService } from 'src/app/core/services/utils/sweet-alert.service';

@Component({
  selector: 'app-modal-motivos-atencion',
  templateUrl: './modal-motivos-atencion.component.html',
  styleUrls: ['./modal-motivos-atencion.component.css']
})
export class ModalMotivosAtencionComponent implements OnInit {
  checkboxGroup!: FormGroup;
  submittedValue: any;
  subscription!: Subscription;
  checkboxes: any;
  seleccion: any;
  observaciones?: FormGroup;
  idTurno!: string;
  motivoIsSubmitted = false;
  respMotivo: any;
  respErrMotivo: any;
  observacion: any;
  cierre!: boolean;
  pausa!: boolean;
  urgencia!: boolean;

  motivosForm!: FormGroup;

  checkboxControl: any;
  valoresCant: any;
  valoresMot: any;
  validaCant: any = [];

  constructor(
    private modalService: ModalService,
    private fb: FormBuilder,
    private atencion: AtencionService,
    private desencripta: DecryptService,
    private emit: EmitService,
    private sweetAlertService: SweetAlertService,
    private localSecureService: LocalService
  ) { }

  ngOnInit() {
    this.checkboxGroup = this.fb.group({
      checkboxes: this.fb.array(this.checkboxes.map((x: any) => false)),
      cantidades: this.fb.array(this.checkboxes.map((x: any) => 1)),
      observaciones: ['']
    });

    this.checkboxControl = this.checkboxGroup.controls.checkboxes as FormArray;
    this.subscription = this.checkboxControl.valueChanges.subscribe((checkbox: any) => {
      this.checkboxControl.setValue(
        this.checkboxControl.value.map((value: any, i: string | number) =>
          value ? this.checkboxes[i].idMotivo : false
        ),
        { emitEvent: false },
      );
      this.motivoIsSubmitted = false;
    });
  }



  submit() {
    const checkboxControl = this.checkboxGroup.controls.checkboxes as FormArray;
    //const cantidades = this.checkboxGroup.controls.cantidades as FormArray;
    this.valoresCant = this.checkboxGroup.controls.cantidades.value as FormArray
    let esValido = true;
    for (let i = 0; i < this.valoresCant.length; i++) {
      if (this.valoresCant[i] > 0) {
        this.validaCant[i] = true;
      } else {
        this.validaCant[i] = false;
        esValido = false;
      }
    }

    this.valoresMot = this.checkboxGroup.controls.checkboxes.value as FormArray;
    const formValue = {
      ...this.checkboxGroup.value,
      checkboxes: checkboxControl.value.filter((value: any) => !!value),
    };
    this.submittedValue = formValue;
    this.seleccion = this.submittedValue.checkboxes.toString();
    this.motivoIsSubmitted = true;

    if (this.seleccion == '') {
      return;
    }
    if (!esValido) {
      return;
    }
    let listaMotivos = ''
    for (let i = 0; i < this.valoresCant.length; i++) {
      if (this.valoresMot[i]) {
        listaMotivos += this.valoresMot[i] + ',' + this.valoresCant[i] + ';';
      }
    }
    if (this.checkboxGroup.controls.observaciones.value == '') {
      this.observacion = "Ninguna"
    } else {
      this.observacion = this.checkboxGroup.controls.observaciones.value
    }

    const dataMotivos = JSON.stringify({
      "idTurno": this.idTurno,
      "listaMotivos": listaMotivos,
      "observacion": this.observacion
    });


    if (this.pausa || this.urgencia) {
      this.enviarMotivos(dataMotivos);
    } else {
      const motivosTurno = {
        listaMotivos: listaMotivos,
        observaciones: this.checkboxGroup.controls.observaciones.value
      }
      this.localSecureService.setValue('motivosTurno', motivosTurno);
      this.closeModal();
      if (this.cierre) {
        this.emit.enviarData('finTurnoSesion');
      } else {
        this.emit.enviarData('finTurno');
      }
    }

  }

  async enviarMotivos(dataMotivos: any) {
    await this.atencion.ingresaMotivos(dataMotivos).then((data) => {
      this.respMotivo = data;
    }).catch((error) => {
      this.respErrMotivo = error;
    });

    if (this.respMotivo) {
      this.closeModal();
      if (this.cierre) {
        this.emit.enviarData('finTurnoSesion');
      } else {
        if (this.pausa) {
          this.emit.enviarData('finTTurno');
        } else {
          if (this.urgencia) {
            this.emit.enviarData('urgencia');
          }
        }
      }
    } else {
      this.closeModal();
      this.emit.enviarData('failPausa');
    }

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  closeModal(): void {
    this.modalService.closeModal();
  }

  cerrar() {
    this.sweetAlertService.swalClose();
    this.closeModal();
    /* if (this.tipo == 'derivar') {
      this.emit.enviarData('continuar');
    } */
  }

/*   mostrarModalOffline(viene: string) {
    const opciones = { class: '', initialState: { viene: viene } };
    this.modalService.openModal(ModalOfflineComponent, opciones);
  } */

}
